import { Box, BoxProps, Typography } from "@mui/material";
import { FC, ReactNode } from "react";
import { HFieldProps } from "../../types";
import { HypeIcon } from "../HypeIcon";

export type ResultVariantType = "success" | "info" | "error" | "warning";
type ResultType = Record<
  ResultVariantType,
  {
    iconName: HypeIconName;
    iconColor: THypeColors;
  }
>;
const resultTypes: ResultType = {
  success: {
    iconName: "status_success",
    iconColor: "primary.main",
  },
  warning: {
    iconName: "status_alert",
    iconColor: "warning.main",
  },
  error: {
    iconName: "status_error",
    iconColor: "error.main",
  },
  info: {
    iconName: "icon_info",
    iconColor: "info.main",
  },
};

export type HResultProps = HFieldProps & {
  iconName?: HypeIconName;
  iconColor?: THypeColors;
  wrapperProps?: BoxProps;
  children?: ReactNode;
};

export const HResult: FC<HResultProps> = ({
  text,
  textVariant = "bodyMedium",
  labelSecondary,
  resultVariant,
  iconName: iconNameProp,
  iconColor: iconColorProp,
  wrapperProps,
  children,
}) => {
  const { iconColor, iconName } = resultTypes[resultVariant || "warning"];
  return (
    <Box
      role="banner"
      {...wrapperProps}
      sx={{
        gap: 6,
        display: "flex",
        width: "100%",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        mt: { xs: "150px", sm: 11 },
        ...wrapperProps?.sx,
      }}
    >
      <HypeIcon
        name={iconNameProp || iconName}
        size={140}
        color={iconColorProp || iconColor}
      />
      <Typography
        variant={textVariant}
        textAlign="center"
        fontSize="18px"
        dangerouslySetInnerHTML={{ __html: text || "" }}
      />
      <Typography
        variant="body"
        textAlign="center"
        sx={{ color: "secondary.main" }}
        dangerouslySetInnerHTML={{ __html: labelSecondary || "" }}
      />
      {children}
    </Box>
  );
};

export default HResult;
